'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownFormField = undefined;
var _jsxFileName = 'src/index.js';

var _templateObject = _taggedTemplateLiteral(['\n\n  &:not(.is-open) .Select-control {\n    background-color: transparent !important;\n  }\n\n  &:not(.is-open) .Select-control {\n      border: 1px transparent solid !important;\n      \n      box-shadow: none;\n      \n      ', '\n  }\n  \n  & .Select-option.is-focused {\n    background: #f3f3f3;\n  }\n  \n  & .Select-option.is-selected {\n    background-color: #fafafa;\n  }\n  \n  .Select-input > input {\n    color: gray;\n  }\n  \n  .Select-arrow {\n    background-image: url("', '");\n    border: none;\n    display: inline-block;\n    width: 15.5px;\n    height: 8px;\n    background-size: 15.5px 8px;\n  }\n  \n  &.Select.is-focused:not(.is-open) > .Select-control {\n    box-shadow: none;\n  }\n  \n  .Select-menu-outer {\n      z-index: 9;\n  }\n  \n  &:not(.is-open) .Select-value-label {\n    ', '\n  }\n  \n  &:not(.is-open) .Select-control .Select-value {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n'], ['\n\n  &:not(.is-open) .Select-control {\n    background-color: transparent !important;\n  }\n\n  &:not(.is-open) .Select-control {\n      border: 1px transparent solid !important;\n      \n      box-shadow: none;\n      \n      ', '\n  }\n  \n  & .Select-option.is-focused {\n    background: #f3f3f3;\n  }\n  \n  & .Select-option.is-selected {\n    background-color: #fafafa;\n  }\n  \n  .Select-input > input {\n    color: gray;\n  }\n  \n  .Select-arrow {\n    background-image: url("', '");\n    border: none;\n    display: inline-block;\n    width: 15.5px;\n    height: 8px;\n    background-size: 15.5px 8px;\n  }\n  \n  &.Select.is-focused:not(.is-open) > .Select-control {\n    box-shadow: none;\n  }\n  \n  .Select-menu-outer {\n      z-index: 9;\n  }\n  \n  &:not(.is-open) .Select-value-label {\n    ', '\n  }\n  \n  &:not(.is-open) .Select-control .Select-value {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

require('react-select/dist/react-select.css');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledSelect = (0, _styledComponents2.default)(_reactSelect2.default)(_templateObject, function (_ref) {
  var profile = _ref.profile;

  if (profile == 'CALCULATOR_CAR_MODEL') {
    return 'text-align: center;';
  } else {
    return '';
  }
}, require('../assets/dropdown-arrow.png'), function (_ref2) {
  var profile = _ref2.profile;

  if (profile == 'CALCULATOR_CAR_MODEL') {
    return 'font-size: 27px;';
  } else {
    return '';
  }
});
exports.default = StyledSelect;
var DropdownFormField = exports.DropdownFormField = function DropdownFormField(_ref3) {
  var input = _ref3.input,
      meta = _ref3.meta,
      options = _ref3.options,
      className = _ref3.className,
      clearable = _ref3.clearable;

  return _react2.default.createElement(StyledSelect, { className: className,
    value: input.value,
    disabled: input.disabled,
    clearable: clearable,
    onChange: input.onChange,
    onFocus: input.onFocus,
    onBlur: function onBlur(e) {
      return input.onBlur && input.onBlur(input.value);
    },
    options: options, __source: {
      fileName: _jsxFileName,
      lineNumber: 74
    },
    __self: undefined
  });
};


//////////////////
// WEBPACK FOOTER
// ../component-dropdown/dist/index.js
// module id = 368
// module chunks = 0